import request from '@/utils/request'

export function index(bibleCode) {
  return request({
    url: '/bible' + (bibleCode ? '/' + bibleCode : ''),
    method: 'get',
  })
}

export function chapter(bibleCode, bibleBookCode, chapterOrder) {
  return request({
    url: '/bible/' + bibleCode + '/' + bibleBookCode + '/' + chapterOrder,
    method: 'get'
  })
}

export function verse(bibleCode, bibleBookCode, chapterOrder, verseOrder) {
  return request({
    url: '/bible/' + bibleCode + '/' + bibleBookCode + '/' + chapterOrder + '/' + verseOrder,
    method: 'get'
  })
}

export function search(bibleCode, bibleBookCode, keyword, skip) {
  return request({
    url: '/bible/' + bibleCode + '/search',
    params: {
      q: keyword,
      book: bibleBookCode,
      skip: skip ? skip : 0,
    },
    method: 'get'
  })
}

